import React from "react";
import { object, func } from "prop-types";
import Col from "../../../common/grid/Col";
import Row from "../../../common/grid/Row";
import Button from "../../../common/button/Button";

const FileCard = ({ file, onDelete, onDownload }) => {
  return (
    <div className="file">
      <Col _bottom-16>
        <Col _bottom-8>
          <h2>{file.fileCaption}</h2>
        </Col>

        <div className="divider" />

        <Row _no-grow _gap-16 _flex-end>
          <Button onClick={(e) => onDownload(file, e)} className={"btn-plain"}>
            DOWNLOAD
          </Button>
        </Row>
      </Col>
    </div>
  );
};

FileCard.propTypes = {
  onDownload: func,
  onDelete: func,
  file: object
};

export default FileCard;



// WEBPACK FOOTER //
// ./src/components/main/files/FileCard.js